import * as C from './styles'
import { Theme } from '../../components/Theme/intex'
import { useForm, FormActions } from '../../context/FormContext'
import { useEffect } from 'react'
import { ReactComponent as CheckIcon } from '../../svgs/check.svg'
import { useHistory } from 'react-router-dom'

export const FormStep4 = () => {
    const { state, dispatch } = useForm();
    const history = useHistory();

    useEffect(() => {
        if (state.name === '') {
            history.push('/');
        } else {
            dispatch({
                type: FormActions.setCurrentStep,
                payload: 4
            });
        }
    }, []);

    const handleFinish = () => {
        // Limpar todos os formulários após concluir
        dispatch({ type: FormActions.setName, payload: '' });
        dispatch({ type: FormActions.setLevel, payload: 0 });
        dispatch({ type: FormActions.setEmail, payload: '' });
        dispatch({ type: FormActions.setGithub, payload: '' });
        dispatch({ type: FormActions.setCnpj, payload: '' });
        dispatch({ type: FormActions.setPhone, payload: '' });
        dispatch({ type: FormActions.setIp, payload: '' });
        dispatch({ type: FormActions.setOs, payload: 'Link' });

        // Redireciona para a página inicial após limpar o estado
        history.push('/');
    };

    return (
        <Theme>
            <C.Container>
                <h2>Parabéns {state.name}</h2>
                <p>Cadastro enviado com sucesso!</p>

                <C.IconArea>
                    <CheckIcon fill="rgb(0, 107, 219)" width={120} height={120} />
                </C.IconArea>

                <p className='check-email'>
                    Enviaremos um e-mail para: <b>{state.email}</b><br /> 
                    E uma notificação no Whatsapp <b>{state.phone}</b><br /> 
                    quando este host estiver indisponível
                </p>

                <C.Button onClick={handleFinish}>Concluir</C.Button>
            </C.Container>
        </Theme>
    );
}
